// Curated Font Awesome registry.
//
// Importing each icon individually (instead of the whole `fas`/`fab` sets)
// keeps ~2000 unused glyphs out of the main bundle. This module is imported
// for its side effect in main.ts before the app mounts.
//
// Every name here corresponds to a kebab-case icon requested somewhere in the
// app (`['fas', 'name']` / `['fab', 'name']`). If you add a new icon
// reference in a template or helper, register it here or it will render blank.
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faA, faArrowDownShortWide, faArrowLeft, faArrowRight, faArrowUpRightFromSquare, faBars,
  faBell, faBook, faBookOpen, faBriefcase, faBullhorn, faBullseye, faCalculator, faCalendar,
  faCalendarAlt, faCalendarDay, faCalendarDays, faCalendarWeek, faCamera, faChalkboardUser,
  faCheck, faCheckCircle, faChevronDown, faChevronLeft, faChevronRight, faCircleCheck,
  faCircleExclamation, faCircleInfo, faCircleNotch, faCircleQuestion, faClipboardList, faClock,
  faCloudArrowUp, faComment, faCommentDots, faComments, faDownload, faEllipsis,
  faEllipsisVertical, faEnvelope, faEnvelopeCircleCheck, faExclamationTriangle, faEye,
  faEyeSlash, faFile, faFileArrowDown, faFileArrowUp, faFileCsv, faFileExcel, faFileImage,
  faFileImport, faFileLines, faFilePdf, faFilePowerpoint, faFileWord, faFilter, faFlag,
  faFlagCheckered, faFlask, faFolderOpen, faGear, faGift, faGlobe, faGraduationCap,
  faGripVertical, faHashtag, faHouse, faHouseUser, faIdCard, faImage, faInfoCircle,
  faLayerGroup, faLink, faLinkSlash, faListOl, faLocationDot, faLock, faMagnifyingGlass,
  faNoteSticky, faPaperPlane, faPaperclip, faPen, faPencil, faPercent, faPhotoFilm, faPlus,
  faPowerOff, faPuzzlePiece, faReceipt, faRightFromBracket, faRotateLeft, faRuler,
  faSatelliteDish, faSchool, faShapes, faShieldHalved, faSliders, faSpinner, faStar,
  faStickyNote, faTable, faTableCells, faTableColumns, faTag, faThumbtack, faTowerBroadcast,
  faTrash, faTriangleExclamation, faUpload, faUser, faUserCheck, faUserGroup, faUserPlus,
  faUserTag, faUsers, faUsersRectangle, faWandMagicSparkles, faXmark,
} from '@fortawesome/free-solid-svg-icons'
import {
  faGoogle,
} from '@fortawesome/free-brands-svg-icons'

library.add(
  faA, faArrowDownShortWide, faArrowLeft, faArrowRight, faArrowUpRightFromSquare, faBars,
  faBell, faBook, faBookOpen, faBriefcase, faBullhorn, faBullseye, faCalculator, faCalendar,
  faCalendarAlt, faCalendarDay, faCalendarDays, faCalendarWeek, faCamera, faChalkboardUser,
  faCheck, faCheckCircle, faChevronDown, faChevronLeft, faChevronRight, faCircleCheck,
  faCircleExclamation, faCircleInfo, faCircleNotch, faCircleQuestion, faClipboardList, faClock,
  faCloudArrowUp, faComment, faCommentDots, faComments, faDownload, faEllipsis,
  faEllipsisVertical, faEnvelope, faEnvelopeCircleCheck, faExclamationTriangle, faEye,
  faEyeSlash, faFile, faFileArrowDown, faFileArrowUp, faFileCsv, faFileExcel, faFileImage,
  faFileImport, faFileLines, faFilePdf, faFilePowerpoint, faFileWord, faFilter, faFlag,
  faFlagCheckered, faFlask, faFolderOpen, faGear, faGift, faGlobe, faGraduationCap,
  faGripVertical, faHashtag, faHouse, faHouseUser, faIdCard, faImage, faInfoCircle,
  faLayerGroup, faLink, faLinkSlash, faListOl, faLocationDot, faLock, faMagnifyingGlass,
  faNoteSticky, faPaperPlane, faPaperclip, faPen, faPencil, faPercent, faPhotoFilm, faPlus,
  faPowerOff, faPuzzlePiece, faReceipt, faRightFromBracket, faRotateLeft, faRuler,
  faSatelliteDish, faSchool, faShapes, faShieldHalved, faSliders, faSpinner, faStar,
  faStickyNote, faTable, faTableCells, faTableColumns, faTag, faThumbtack, faTowerBroadcast,
  faTrash, faTriangleExclamation, faUpload, faUser, faUserCheck, faUserGroup, faUserPlus,
  faUserTag, faUsers, faUsersRectangle, faWandMagicSparkles, faXmark,
  faGoogle,
)
